import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { beforeItems, afterItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-ink-950 py-12 sm:py-16" aria-labelledby="ba-title" data-id="element-59" data-mp="26lutcc89j2bx">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-60" data-mp="22kre9ry1habr">
        <p className="text-center font-display text-sm font-bold uppercase tracking-[0.15em] text-steel-500" data-id="element-61" data-mp="22mc4j5dbm73t">
          From “just another technician”…
        </p>
        <h2 id="ba-title" className="mt-2 text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-white sm:text-4xl" data-id="element-62" data-mp="2ubp50qguikul">
          …to a technician who looks, communicates, and operates like a{' '}
          <span className="text-gold-500" data-id="element-63" data-mp="2ldd7e4hkamsn">premium service business</span>
        </h2>

        <div className="mt-8 space-y-5 lg:grid lg:grid-cols-2 lg:gap-5 lg:space-y-0" data-id="element-64" data-mp="1ewhwd13y56pw">
          <div className="overflow-hidden rounded-2xl border border-red-500/30 bg-ink-900" data-id="element-65" data-mp="19uis7p0du5rw">
            <div className="flex items-center gap-2 bg-red-600/15 px-4 py-3" data-id="element-66" data-mp="176no5xatjb7j">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-600" data-id="element-67" data-mp="1c4p6gg0f76hy">
                <XIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-68" data-mp="y3mnic4q2cb9" />
              </span>
              <h3 className="font-display text-base font-extrabold uppercase leading-tight tracking-wide text-red-300 sm:text-lg" data-id="element-69" data-mp="132prrucvoei6">
                Before the Premium Technician Kit™
              </h3>
            </div>
            <ul className="divide-y divide-white/[0.07]" data-id="element-70" data-mp="t75y7elsdrwl">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5 px-4 py-3 text-sm leading-snug text-steel-300 sm:text-base" data-id="element-71" data-mp="ffrf77rvpqpj">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-72" data-mp="5hblqy5dq5cv" />
                  <span data-id="element-73" data-mp="2c499mkw9yxid">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-2xl border border-gold-500/40 bg-ink-900 shadow-[0_0_0_1px_rgba(245,168,20,0.15)]" data-id="element-74" data-mp="27dsv0xgpx5uf">
            <div className="flex items-center gap-2 bg-gold-500/15 px-4 py-3" data-id="element-75" data-mp="23d0k7zs76sw1">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-green-500" data-id="element-76" data-mp="1yde5tn0mv6ln">
                <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-77" data-mp="2v3epx8q24ywm" />
              </span>
              <h3 className="font-display text-base font-extrabold uppercase leading-tight tracking-wide text-gold-400 sm:text-lg" data-id="element-78" data-mp="2r19ymgn30ed5">
                With the Premium Technician Kit™
              </h3>
            </div>
            <ul className="divide-y divide-white/[0.07]" data-id="element-79" data-mp="2h2kioteqx3zj">
              {afterItems.map(item => <li key={item} className="flex items-start gap-2.5 px-4 py-3 text-sm font-medium leading-snug text-white sm:text-base" data-id="element-80" data-mp="1aouzhd1593w7">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-400" aria-hidden="true" data-id="element-81" data-mp="vll5cp0jzrr6" />
                  <span data-id="element-82" data-mp="15ipu8wlsa1bo">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-83" data-mp="1a9elcatjwwaa">
          <CTAButton label="I want to look more professional" sub="One-time payment of $27 USD" size="md" data-id="element-84" data-mp="1ab97ttkh0wgh" />
        </div>
      </div>
    </section>;
}